import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import ProductImage from "../Common/ProductImage";

const useStyles = makeStyles((theme) => ({
  tableCell:{
    padding: theme.spacing(1)
  },
  imagesContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.5),
    justifyContent: "center",
    alignItems: "center",
    maxWidth: "200px",
  },
  smallImageWrapper: {
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
  groupImageCell: {
    width: "60px",
    textAlign: "center",
    border: "solid 1px #DDD",
    padding: theme.spacing(0.5),
  },
  groupTableRow: {
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
}));

export default function SimilarListItem({similarGroup, openManageSimilarGroupDialog} ) {
  const classes = useStyles();
  
  return (
      <TableRow key={similarGroup.id}>
        <TableCell align="center" className={classes.tableCell}>{similarGroup.id}</TableCell>
        <TableCell align="center" className={classes.tableCell}>
          <div className={classes.imagesContainer}>
              <div className={classes.smallImageWrapper}>
                <ProductImage 
                  product_matching_group_id={similarGroup.id} 
                  width={'50px'} 
                  height={'50px'}
                  hide_multiple_icon={true}
                  popup_open={false}
                />
              </div>            
          </div>
        </TableCell>
        <TableCell align="left"  className={classes.tableCell}>
            <table style={{width:"100%"}}>
              {similarGroup.groups.map((group, index)=>(
                <tr key={index} className={classes.groupTableRow}>
                  <td className={classes.groupImageCell}>
                    <div className={classes.smallImageWrapper}>
                      <ProductImage 
                        product_matching_group_id={group.id} 
                        width={'40px'} 
                        height={'40px'}
                        hide_multiple_icon={true}
                        popup_open={false}
                      />
                    </div>
                  </td>
                  <td style={{border:"solid 1px #DDD"}}>{group.name}</td>
                  <td style={{width:"50px",textAlign:"center",border:"solid 1px #DDD"}} >{group.size}</td>
                  <td style={{width:"50px",textAlign:"center",border:"solid 1px #DDD"}}>{group.products_count}</td>
                </tr>
              ))}
            </table>            
        </TableCell>
        {/* <TableCell align="center" className={classes.tableCell}>{similarGroup.count}</TableCell> */}
        <TableCell align="center"  className={classes.tableCell}>{similarGroup.groups.length}</TableCell>
        <TableCell align="center"  className={classes.tableCell}>
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => openManageSimilarGroupDialog(similarGroup.groups[0])}
          >
            Manage
          </Button>
        </TableCell>
      </TableRow>
  );
}
